export default function About() {
  return (
    <section id="about" className="aboutSection">
      <div className="aboutContainer">
        <div className="aboutContent">
          <h2 className="aboutTitle">About Us</h2>
          <p className="aboutText">
            We are a family-run farm providing fresh, unprocessed milk straight from healthy cows. Our commitment to
            quality and tradition ensures that every drop of milk we deliver maintains the highest standards of purity
            and nutrition.
          </p>
        </div>
      </div>
    </section>
  );
}